import { TSelectOptions } from '../components/Select/type';

export const getCurrentSelectItem = (value: string, options: TSelectOptions) => {
  const el = options.find((el) => el.value === value);
  return el;
};
